<template>
    <SectionBase class="DashboardFunctionalBraintrainingSection" :title="$t('title')" :text="$t('text')">
        <template v-slot:items>
            <GameItem v-for="gameId of gameIds" :key="gameId" class="GameItem" :game-id="gameId" />
        </template>
    </SectionBase>
</template>

<translations>
  title: 'Functional brain games'
  title_no: 'Funksjonelle hjernespill'
  text: 'Stay ahead of change by gaming yourself to better days and a top-trained brain.'
  text_no: 'Spill deg til en topptrent hjerne'
</translations>

<script>
import SectionBase from './SectionBase';

import GameItem from './GameItem';

export default {
    components: { SectionBase, GameItem },
    computed: {
        gameIds() {
            return this.$store.state.moduleMemogenius.gameIds;
        }
    }
};
</script>

<style lang="scss" scoped>
.GameItem {
    width: (286em / 15);
    /deep/ .card {
        height: (183em / 15);
    }
}
</style>
